import { getTranslation as w } from "@owc/aem-translations-util";
import { initializeLogger as y } from "@seamless/logger";
import { ref as m, computed as A, onMounted as D, onBeforeUnmount as L, onErrorCaptured as R, getCurrentInstance as V, onUnmounted as B } from "vue";
import { subscribe as C } from "@seamless/one-context";
import { SeamlessConnection as H, initializeStore as k } from "@seamless/store";
const b = {
  separator: "-",
  id: "35e68f8b5769ffbe51d5e3e245f7498f"
}, E = {
  separator: "-",
  id: "256327257efa0b223e1fa85ba6b0cbf7"
}, v = {
  separator: "_",
  id: "42b5f1b854ae37cc8b351c232bf6cb79"
}, ae = "SCCS_MBTI-DISCO-AIR", ne = ["Mercedes-AMG", "MERCEDES_AMG"], te = Symbol.for("componentId"), re = "Mercedes-Benz";
async function F(e) {
  return new Promise((a) => {
    C("PageConnection", {
      tenant: "sccs",
      componentName: "air-tnt",
      callback: (r) => {
        a(`${r.pageEnvironmentVariables.language}${e}${r.pageEnvironmentVariables.country}`);
      }
    });
  });
}
async function G() {
  return new Promise((e) => {
    C("PageConnection", {
      tenant: "sccs",
      componentName: "air-tnt",
      callback: (a) => {
        e(a.pageEnvironmentVariables.country);
      }
    });
  });
}
const U = async (e) => await F(e), oe = async () => await G(), g = y("DH_IO_SCSS/I18N");
let N = null;
const p = m({}), d = m({}), I = m({});
function se() {
  const e = async (n) => {
    let t = await U(n);
    return t === `de${n}AQ` && (t = `de${n}DE`), t === `en${n}AQ` && (t = `en${n}AU`), t;
  };
  async function a() {
    return N ? g.log("translations already loaded by another component, using that response") : (g.log("fetching translations"), N = new Promise((n) => {
      (async () => {
        try {
          p.value = await w(
            await e(v.separator),
            v.id,
            "i18next"
          );
        } catch (t) {
          throw new Error(
            `CMN_I18N_CMP: Failed to fetch compare translations for market ${await e(v.separator)}`,
            { cause: t }
          );
        }
        try {
          d.value = await w(
            await e(b.separator),
            b.id,
            "i18next"
          );
        } catch (t) {
          throw new Error(
            `CMN_I18N_DCP: Failed to fetch DCP translations for market ${await e(b.separator)}`,
            { cause: t }
          );
        }
        try {
          I.value = await w(
            await e(E.separator),
            E.id,
            "i18next"
          );
        } catch (t) {
          throw new Error(
            `CMN_I18N_OT: Failed to fetch OneTeaser translations for market ${await e(E.separator)}`,
            { cause: t }
          );
        }
        g.log("translations loaded", {
          compareTranslations: p.value,
          dcpTranslations: d.value,
          oneTeaserTranslations: I.value
        }), n();
      })();
    })), N;
  }
  function r(n) {
    return !!c(n, p.value) || !!c(n, d.value);
  }
  function s(n, t) {
    if (!n)
      return "";
    const o = c(n, p.value) || c(n, d.value) || c(n, I.value) || n;
    return f(o, t);
  }
  function c(n, t) {
    return n.split(".").reduce((o, l) => {
      if (o)
        return o[l];
    }, t);
  }
  function f(n, t) {
    if (!t)
      return n;
    let o = n;
    return Object.entries(t).forEach((l) => {
      const [i, u] = l;
      o = o.replace(`{{${i}}}`, u), o = o.replace(`{{ ${i} }}`, u), o = o.replace(`{${i}}`, u), o = o.replace(`{ ${i} }`, u);
    }), o;
  }
  return { loadTranslations: a, t: s, existsWithoutFallback: r };
}
/*! connection-aem-environment 2.8.0 */
const S = "OWC_AEM_ENV", W = new class extends H {
  constructor() {
    super(S);
  }
  get initialState() {
    const e = window.aemNamespace?.environmentVariables || window.top?.aemNamespace?.environmentVariables, a = window.aemNamespace?.pageEnvironmentVariables || window.top?.aemNamespace?.pageEnvironmentVariables;
    return e && a ? { ...e, ...a } : {};
  }
  getReducer() {
    return () => this.initialState;
  }
  getPublicDispatchers() {
    return {};
  }
}(), x = async () => {
  const e = k();
  return await (async () => {
    if (!window.top?.aemNamespace && !window.aemNamespace) return new Promise((a) => {
      let r;
      Object.defineProperty(window.top, "aemNamespace", { get: () => r, async set(s) {
        r = s, a();
      } });
    });
  })(), await (async () => {
    if (!window.top?.aemNamespace?.environmentVariables && !window?.aemNamespace?.environmentVariables) return new Promise((a) => {
      let r;
      Object.defineProperty(window.top?.aemNamespace, "environmentVariables", { get: () => r, set(s) {
        r = s, a();
      } });
    });
  })(), await (async () => {
    if (!window.top?.aemNamespace?.pageEnvironmentVariables && !window?.aemNamespace?.pageEnvironmentVariables) return new Promise((a) => {
      let r;
      Object.defineProperty(window.top?.aemNamespace, "pageEnvironmentVariables", { get: () => r, set(s) {
        r = s, a();
      } });
    });
  })(), e.addConnection(W);
};
function j(e, a, r) {
  return !a || !r ? "" : `${a}${e[1]}${r}`;
}
const P = m(""), h = m(""), _ = m(""), T = m(!1), z = A(() => j`${_.value}_${h.value}`);
function ie(e) {
  let a;
  return D(async () => {
    x(), a = await e.subscribe(
      S,
      (r) => {
        P.value = r.stage, h.value = r.country, _.value = r.language, T.value = !0;
      }
    ).unsubscribe;
  }), L(() => {
    a?.();
  }), {
    environment: P,
    country: h,
    language: _,
    marketId: z,
    aemLoaded: T
  };
}
function O(e) {
  throw Error(e);
}
var K = /* @__PURE__ */ ((e) => (e[e.COMPONENT = 1] = "COMPONENT", e[e.DATALOADING = 2] = "DATALOADING", e[e.IMAGE = 3] = "IMAGE", e[e.PLS = 4] = "PLS", e[e.FCIS = 5] = "FCIS", e))(K || {}), Q = /* @__PURE__ */ ((e) => (e.CRITICAL = "CRITICAL", e.HIGH = "HIGH", e.MEDIUM = "MEDIUM", e.LOW = "LOW", e))(Q || {});
function Y({ error: e, severity: a, component: r, message: s }, c) {
  switch (a) {
    case "CRITICAL":
    case "HIGH":
      c?.error("An error has been encountered, please find more information below"), c?.table({
        severity: a,
        category: r,
        message: s,
        cause: e?.cause?.message
      });
      break;
    case "MEDIUM":
    case "LOW":
    default:
      c?.log(`Error in component ${r} with severity ${a}: ${s}`, e);
      break;
  }
}
const ce = (e) => {
  const a = m(/* @__PURE__ */ new Map());
  R((n, t, o) => {
    const l = t, i = l._.type.__name === "ErrorBoundary" ? V() ?? O("could not find vue instance") : l._, u = i.exposed?.severity ?? "CRITICAL", $ = i.exposed?.category ?? 1, M = { error: n, severity: u, component: $, message: n.message };
    if (r(i, M), Y(M, e.logger), e.onErrorCallback?.(), !e.allowPropagation) return !1;
  }), D(() => {
    s();
  }), B(() => {
    s();
  });
  function r(n, { error: t, severity: o, component: l }) {
    const i = n.type.name ?? n.type.__name ?? O("a component catching errors must have a name");
    if (a.value.has(i)) {
      const u = a.value.get(i);
      if (!u) return;
      a.value.set(i, [
        ...u,
        { error: t, severity: o, component: l, message: t?.message ?? "" }
      ]);
    } else
      a.value.set(i, [
        { error: t, severity: o, component: l, message: t?.message ?? "" }
      ]);
  }
  function s() {
    a.value.clear();
  }
  const c = A(() => !!a.value.size), f = A(() => Array.from(a.value.values()).reduce((n, t) => n + t.length, 0));
  return { componentsWithErrors: a, hasErrors: c, errorCount: f };
};
export {
  K as C,
  ne as D,
  b as P,
  Q as S,
  oe as a,
  _ as b,
  h as c,
  T as d,
  P as e,
  z as f,
  ie as g,
  Y as h,
  ce as i,
  E as j,
  v as k,
  U as l,
  ae as m,
  te as n,
  re as o,
  O as r,
  se as u
};
//# sourceMappingURL=useErrorCapturer-Uvzw3qyw.js.map
